import { Component, OnInit } from '@angular/core';
import { EmbeddingContext, createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { StatisticheApiService } from 'src/api/statistiche-api.service';

@Component({
  selector: 'app-quicksight-smart-summary',
  templateUrl: './quicksight-smart-summary.component.html',
  styleUrls: ['./quicksight-smart-summary.component.css']
})
export class QuicksightSmartSummaryComponent implements OnInit{
 loadingError = false;
  dashboard: any;

  constructor(private statisticheApiService: StatisticheApiService) {}
  ngOnInit(): void {
    this.getDashboardURL();
  }

  public async getDashboardURL() {
    this.statisticheApiService
      .getQuickSightLinkForSmartSummary()
      .then((data: any) => {
        console.log(data.embedUrl);
        this.Dashboard(data.embedUrl);
      })
      .catch((error: any) => {
        this.loadingError = true;
        console.error('Error fetching dashboard URL for Sic Ania:', error);
      });
  }

  public async Dashboard(embeddedURL: any) {
    console.log('embeddedURL', embeddedURL);
    const containerDiv = document.getElementById('dashboardContainerSmartSummary') || '';
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      height: '850px',
      width: '100%',
      resizeHeightOnSizeChangedEvent: true,
    };
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    this.dashboard = embeddingContext.embedDashboard(frameOptions);
  }

}
